import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem("alsat67_cookie_consent"));

  const decide = (value) => {
    localStorage.setItem("alsat67_cookie_consent", JSON.stringify({ choice: value, at: new Date().toISOString() }));
    setChoice(value);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-20 md:bottom-4 inset-x-3 sm:inset-x-auto sm:left-4 sm:max-w-lg z-50 rounded-2xl border border-black/10 bg-white/97 backdrop-blur-xl p-5 shadow-2xl"
          data-testid="cookie-consent-banner"
        >
          <div className="flex items-start gap-3">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-amber2/20 text-amber-600">
              <Cookie size={20} />
            </span>
            <div>
              <h4 className="font-display font-bold">Çerez Tercihleriniz</h4>
              <p className="mt-1 text-[13px] leading-relaxed text-slate-600">
                alsat67.com'da daha iyi bir deneyim için çerezler kullanılmaktadır. Oturum çerezleri zorunludur;
                tercih çerezleri ise yalnızca onayınızla çalışır.{" "}
                <Link to="/cerez-politikasi" data-testid="cookie-policy-link" className="font-semibold text-coral underline underline-offset-2">
                  Çerez Politikamızı
                </Link>{" "}
                ve{" "}
                <Link to="/kvkk-aydinlatma-metni" className="font-semibold text-coral underline underline-offset-2">
                  KVKK Aydınlatma Metnimizi
                </Link>{" "}
                inceleyebilirsiniz.
              </p>
            </div>
          </div>
          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <button
              data-testid="cookie-accept-button"
              onClick={() => decide("all")}
              className="flex-1 rounded-full bg-coral px-4 py-2.5 text-sm font-bold text-white hover:bg-coraldark transition"
            >
              Tümünü Kabul Et
            </button>
            <button
              data-testid="cookie-reject-button"
              onClick={() => decide("minimal")}
              className="flex-1 rounded-full border border-slate-300 px-4 py-2.5 text-sm font-semibold hover:border-coral hover:text-coral transition"
            >
              Sadece Zorunlu Çerezler
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
